import Vue from "vue"

Vue.prototype.$api = "https://api.campdraft.com.au"
Vue.prototype.$coy = "https://nominate.campdraft.com.au"

Vue.prototype.$trialApplicationFilePath = '/static/files/EXT027.pdf'
Vue.prototype.$openApplicationFilePath = '/static/files/EXT028.pdf'

Vue.prototype.$sentry = {
  dsn: "https://1c61c7a426c14ee0953485ec14eabe56@o1070396.ingest.sentry.io/6067940",
  environment: "production"
}

Vue.prototype.$paypal = {
  production: "AQMOQk4LS_n30mQyp0L5nLx7dJV-ex-l3qLlYS2RYykplhgu5iX-upjyg1zIrEOS_WIW86WqxV5g-c7y",
  sandbox: "AQM6f2Ts_iCveaFNHbuKenv3iIFJUmWD8jxN9RG63AcThcha01BPIby8vwHUyDTSjBozAEfa8LJTbuZ8"
}

Vue.prototype.$stripePk = "pk_live_iNp69gtcmC5qiSdSYkfukavK"
Vue.prototype.$captchaSiteKey = "6Ld6xekrAAAAAAd8cAPUhV9M6SmAXk-dOM27ZvIc"




// WEBPACK FOOTER //
// ./src/router/vars.js